/** @format */

import template from './gb-donation-item-amount-label.html';
import './gb-donation-item-amount-label.scss';

export const GbDonationItemAmountLabelComponent = {
    template,
    controller: class GbDonationItemAmountLabelComponent {
        constructor() {
            'ngInject';
        }
    },
};
